var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_997_25525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7822 16.9366V10.3246L12.5673 0.812278C12.1217 0.296526 11.4739 0 10.7924 0H0L13.9253 16.1244C14.3709 16.6401 15.0186 16.9366 15.7004 16.9366H20.7822Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36.33H10.7909C11.4733 36.33 12.122 36.0329 12.5676 35.5159L20.7825 25.9844V19.3721H15.7011C15.019 19.3721 14.3706 19.6689 13.925 20.1856L0 36.33Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H33.2076C32.5261 0 31.878 0.296526 31.4325 0.812278L23.2175 10.3246V16.9366H28.2996C28.9811 16.9366 29.6292 16.6401 30.0747 16.1244L44 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2175 19.3721V25.9841L31.4325 35.5156C31.878 36.0326 32.5267 36.3297 33.2091 36.3297H44.0004L30.0747 20.1856C29.6292 19.6689 28.9808 19.3721 28.2987 19.3721H23.2175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_997_25525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 36.3302,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/Logomark.27fae306a59a59e095ed420d6a7c0acf.svg";
export { ForwardRef as ReactComponent };